/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IShippingPopupViewProps } from './shipping-popup';

import { Modal, ModalBody, ModalHeader } from '@msdyn365-commerce-modules/utilities';
import { stateSettings } from '../../settings/app.settings';
import { dataStates } from '../shipping-map/shipping-map.data-states';

export default (props: IShippingPopupViewProps) => {

    const {
        shippingPopup__shippingModalTitle,
        shippingPopup__shippingModalDescription,
        shippingPopup__shippingModalLegend
    } = props.resources;

    const states = props.context.app.config.statesSettings as stateSettings || [];

    return (
        <div className='shipping-popup'>
            <Modal
                autoFocus={true}
                fade={true}
                isOpen={props.modalState}
                horizontalPosition='center'
                verticalPosition='center'
                zIndex={1000}
                toggle={props.toggleModal}
                applicationNode='rsg-root'
                modalClassName='wine-club-signup-shipping-modal'
            >
                <ModalHeader toggle={props.toggleModal} />
                <ModalBody>
                    <h2 className='wine-club-signup-shipping-modal-title'>{shippingPopup__shippingModalTitle}</h2>
                    <div className='wine-club-signup-shipping-modal-content'>
                        <div className='wine-club-signup-shipping-modal-map'>
                            {props.slots.map}
                        </div>
                        <div className='wine-club-signup-shipping-modal-description'>
                            <p>{shippingPopup__shippingModalDescription}</p>
                            <p>{shippingPopup__shippingModalLegend}</p>
                            <ul style={{listStyle:'none'}} className='wine-club-signup-shipping-modal-states'>
                                {
                                    Object.keys(states)
                                        .filter(state => !states[state])
                                        .map((state, index) => (<li key={index}>{dataStates[state]}</li>))
                                }
                            </ul>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
            <button onClick={props.toggleModal}>{props.config.shippingButtonText}</button>
        </div>
    );
};
